import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { bmxurl } from 'src/globals';
import { user } from 'src/types/users';
import { users_returndata } from 'src/types/user_returndata';
import { cVenuesettings } from 'src/types/venuesettings';
import { cVenuesetting } from 'src/types/venuesetting';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { BusyService } from '../_services/busy.service';
import { bu } from '@fullcalendar/core/internal-common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-simracing',
  templateUrl: './simracing.component.html',
  styleUrls: ['./simracing.component.css']
})
export class SimracingComponent implements OnInit {

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  httpResponse: any;
  simracingEnabled: boolean = false;
  apiKey: string = "";
  selectedVenue: any = null;
  venues: any[] = [];
  venuesLoading: boolean = false;
  settingsSaving: boolean = false;
  noVenuesMessage: string = "";
  venuesettings: cVenuesettings;
  BNemail: string = "";
  BookingNotification: boolean = false;

  // Settings variables from venuesettings component
  vsDiagnostics: boolean = true;
  vsPBWStyle: string = "DATEFIRST";
  vsMinimalDetails: boolean = true;
  vsImageURL: string = "";
  vsImageReturnURL: string = "";
  vsGTMCode: string = "";
  vsConfirmations: string = "Email";
  defInterval: number = 0;
  imageWidth: number = 0;
  imageHeight: number = 0;
  idleTimeout: number = 0;
  AllowTimeOut: boolean = false;
  RyftSubAccountID: string = "";
  GoogleTagManagerID: string = "";
  returnPage: string = "";
  WebhookURL: string = "";
  NoAvailabilityMessage: string = "There are no times available that match your criteria";
  UseCounters: boolean = false;
  SummaryItinerary: boolean = false;
  IgnoreDateRestrictions: boolean = false;
  defaultColour: string = "#5974af";
  chosenTimezone: any;
  chosenCurrency: any;
  chosenCulture: any;
  BookingsCannotBeMadeWithinXMinutes: number = 0;
  BookingsCannotBeMadeAfterXMinutes: number = 0;
  CannotMakeBookingsToday: boolean = false;
  betaemailing: boolean = false;
  betatask: boolean = false;
  betamembership: boolean = false;
  PaymentAmountSelection: any = "DEPOSIT";
  ChosenHomePage: any = {value: "home", name: "Bookings Created Today"};
  waiverminage: number = 18;
  selectedPaymentLinkEmailTemplate: any;
  selectedVoucherEmailTemplate: any;
  selectedCancelledBookingEmailTemplate: any;
  WaiversActive: boolean = false;
  MinWaiverAge: any = {name: "18 Years", value: 18};
  WaiverMinAgeParticipate: any = {name: "0 Years", value: 0};
  SimRacingEnabled: boolean = false;
  SimRacingAPIKey: string = "";
  SimRacingVenueID: string = "";

  // State options for the toggle
  simracingStateOptions = [
    { label: 'No', value: false },
    { label: 'Yes', value: true }
  ];

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private busyService: BusyService,
    private router: Router
  ) 
  {
    this.getVenueSettings();
  }

  ngOnInit(): void {
    let userid = localStorage.getItem("UserID");
    this.AccessAllowed = true;
    this.loadSimracingSettings();
    this.CompletedLoading = true;
  }
  
  updateSettingsData(showmessage: boolean = true, callback?: () => void){

    //Availability Diagnostics
    let vsDiagnosticsContainer = new cVenuesetting;
    let vsPBWStyleContainer = new cVenuesetting;
    let vsMinimalDetailsContainer = new cVenuesetting;
    let vsImageURLContainer = new cVenuesetting;
    let vsImageReturnURLContainer = new cVenuesetting;
    let vsDefInterval = new cVenuesetting;
    let vsIdleTimeout = new cVenuesetting;
    let vsConfirmation = new cVenuesetting;
    let vsAllowTimeOut = new cVenuesetting;
    let vsUseCounters = new cVenuesetting;
    let vsSummaryItinerary = new cVenuesetting;
    let vsIgnoreDateRestrictions = new cVenuesetting;
    let vsRyftSubAccountID = new cVenuesetting;
    let vsGoogleTagManagerID = new  cVenuesetting;
    let vsReturnPage = new  cVenuesetting;
    let vsWebHookURL = new  cVenuesetting;
    let vsNoAvailabilityMessage = new  cVenuesetting;
    let vsBookingNotificationEmail = new  cVenuesetting;
    let vsBookingNotification = new  cVenuesetting;
    let vsSimRacingEnabled = new cVenuesetting;
    let vsSimRacingAPiKey = new cVenuesetting;
    let vsSimRacingVenueID = new cVenuesetting;


    vsBookingNotificationEmail.name = "BookingNotificationEmail";
    vsBookingNotificationEmail.value = this.BNemail;

    vsBookingNotification.name = "BookingNotification";
    vsBookingNotification.value = String(this.BookingNotification);
  
    vsDiagnosticsContainer.name = "AvailabilityDiagnostics";
    vsDiagnosticsContainer.value = String(this.vsDiagnostics);

    vsPBWStyleContainer.name = "PBWStyle";
    vsPBWStyleContainer.value = String(this.vsPBWStyle);

    vsConfirmation.name = "EMailSMSConfirmation"
    vsConfirmation.value = String(this.vsConfirmations);

    vsDefInterval.name = "DefaultInterval";
    vsDefInterval.value = this.defInterval.toString();

    vsIdleTimeout.name = "idleTimeout";
    vsIdleTimeout.value = this.idleTimeout.toString();

    vsRyftSubAccountID.name = "RyftSubAccountID";
    vsRyftSubAccountID.value =  String(this.RyftSubAccountID);

    vsGoogleTagManagerID.name = "GoogleTagManagerID";
    vsGoogleTagManagerID.value =  String(this.GoogleTagManagerID);

    vsReturnPage.name = "returnPage";
    vsReturnPage.value =  String(this.returnPage);

    vsWebHookURL.name = "WebHookURL";
    vsWebHookURL.value =  String(this.WebhookURL);

    vsNoAvailabilityMessage.name = "NoAvailabilityMessage";
    vsNoAvailabilityMessage.value =  String(this.NoAvailabilityMessage);

    vsAllowTimeOut.name = "AllowTimeOut";
    vsAllowTimeOut.value =  String(this.AllowTimeOut);

    vsUseCounters.name = "UseCounters";
    vsUseCounters.value =  String(this.UseCounters);

    vsSummaryItinerary.name = "SummaryItinerary";
    vsSummaryItinerary.value =  String(this.SummaryItinerary);

    vsIgnoreDateRestrictions.name = "IgnoreDateRestrictions";
    vsIgnoreDateRestrictions.value =  String(this.IgnoreDateRestrictions);

    vsSimRacingEnabled.name = "simracing_enabled";
    vsSimRacingEnabled.value = String(this.SimRacingEnabled);

    vsSimRacingAPiKey.name = "simracing_apikey";
    vsSimRacingAPiKey.value = String(this.SimRacingAPIKey);

    vsSimRacingVenueID.name = "simracing_venueid";
    vsSimRacingVenueID.value = String(this.SimRacingVenueID);

    let vsMinimalDetails = new cVenuesetting;
    vsMinimalDetailsContainer.name = "MinimalDetails";
    vsMinimalDetailsContainer.value = String(this.vsMinimalDetails);

    let vsImageURL = new cVenuesetting;
    vsImageURLContainer.name = "PublicImgURL";
    vsImageURLContainer.value = String(this.vsImageURL);

    let vsImageReturnURL = new cVenuesetting;
    vsImageReturnURLContainer.name = "ImageReturnURL";
    vsImageReturnURLContainer.value = String(this.vsImageReturnURL);  

    let vsGTMCodeContainer = new cVenuesetting;
    vsGTMCodeContainer.name = "GTMCode";
    vsGTMCodeContainer.value = String(this.vsGTMCode);

    let vsImageWidth = new cVenuesetting;
    vsImageWidth.name = "PublicImageWidth";
    vsImageWidth.value = String(this.imageWidth);

    let vsMinWaiverAge = new cVenuesetting;
    vsMinWaiverAge.name = "WaiverMinAge";
    vsMinWaiverAge.value = String(this.MinWaiverAge.value);

    let vsMinWaiverAgeParticipate = new cVenuesetting;
    vsMinWaiverAgeParticipate.name = "MinWaiverAgeParticipate";
    vsMinWaiverAgeParticipate.value = String(this.WaiverMinAgeParticipate.value);

    let vsImageHeight = new cVenuesetting;
    vsImageHeight.name = "PublicImageheight";
    vsImageHeight.value = String(this.imageHeight);

    let vsColour = new cVenuesetting;
    vsColour.name = "DefaultColour";
    vsColour.value = String(this.defaultColour);

    let vsTimezone = new cVenuesetting;
    vsTimezone.name = "TimeZone";
    vsTimezone.value = String(this.chosenTimezone);

    let vsCurrency = new cVenuesetting;
    vsCurrency.name = "Currency";
    vsCurrency.value = String(this.chosenCurrency);

    let vsCulture = new cVenuesetting;
    vsCulture.name = "Culture";
    vsCulture.value = String(this.chosenCulture);

    let vsBookingsCannotBeMadeWithinXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeWithinXMinutes.name = "BookingsCannotBeMadeWithinXMinutes";
    vsBookingsCannotBeMadeWithinXMinutes.value = String(this.BookingsCannotBeMadeWithinXMinutes);

    let vsBookingsCannotBeMadeAfterXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeAfterXMinutes.name = "BookingsCannotBeMadeAfterXMinutes";
    vsBookingsCannotBeMadeAfterXMinutes.value = String(this.BookingsCannotBeMadeAfterXMinutes);

    let vsCannotMakeBookingsToday = new cVenuesetting;
    vsCannotMakeBookingsToday.name = "CannotMakeBookingsToday";
    vsCannotMakeBookingsToday.value = String(this.CannotMakeBookingsToday);

    let vsBetaEmailing = new cVenuesetting;
    vsBetaEmailing.name = "BetaEmailing";
    vsBetaEmailing.value = String(this.betaemailing);

    let vsBetaTask = new cVenuesetting;
    vsBetaTask.name = "BetaTask";
    vsBetaTask.value = String(this.betatask);

    let vsBetamembership = new cVenuesetting;
    vsBetamembership.name = "Betamembership";
    vsBetamembership.value = String(this.betamembership);

    let vsPaymentAmountSelection = new cVenuesetting;
    vsPaymentAmountSelection.name = "PaymentAmountSelection";
    vsPaymentAmountSelection.value = String(this.PaymentAmountSelection);

    let vsChosenHomePage = new cVenuesetting;
    if(this.ChosenHomePage != null)
    {
      vsChosenHomePage.name = "ChosenHomePage";
      vsChosenHomePage.value = String(this.ChosenHomePage.value);
    }

    let vsWaiverMinAge = new cVenuesetting;
    vsWaiverMinAge.name = "waiverminage";
    vsWaiverMinAge.value = String(this.waiverminage);

    let vsSelectedPaymentLinkEmailTemplate = new cVenuesetting;
    if(this.selectedPaymentLinkEmailTemplate != null)
    {
      vsSelectedPaymentLinkEmailTemplate.name = "PaymentLinkEmailTemplate";
      vsSelectedPaymentLinkEmailTemplate.value = String(this.selectedPaymentLinkEmailTemplate.emailtemplateid);
    }

    let vsSelectedVoucherEmailTemplate = new cVenuesetting;
    if(this.selectedVoucherEmailTemplate != null)
    {
      vsSelectedVoucherEmailTemplate.name = "VoucherEmailTemplate";
      vsSelectedVoucherEmailTemplate.value = String(this.selectedVoucherEmailTemplate.emailtemplateid);
    }

    let vsSelectedCancelledBookingEmailTemplate = new cVenuesetting;
    if(this.selectedCancelledBookingEmailTemplate != null)
    {
      vsSelectedCancelledBookingEmailTemplate.name = "CancelledBookingTemplate";
      vsSelectedCancelledBookingEmailTemplate.value = String(this.selectedCancelledBookingEmailTemplate.emailtemplateid);
    }

    let vsWaiverActive = new cVenuesetting;
    vsWaiverActive.name = "WaiverActive";
    vsWaiverActive.value = String(this.WaiversActive);

    let AllValid: boolean = true;

    if(AllValid)
    {
      this.venuesettings = {
        id: localStorage.getItem("VenueSettingsID"),
        venueid: this.VenueID,
        venuesettings: [
          vsDiagnosticsContainer,
          vsPBWStyleContainer,
          vsMinimalDetailsContainer,
          vsGTMCodeContainer,
          vsImageURLContainer,
          vsImageReturnURLContainer,
          vsConfirmation,
          vsDefInterval,
          vsImageWidth,
          vsImageHeight,
          vsIdleTimeout,
          vsAllowTimeOut,
          vsUseCounters,
          vsSummaryItinerary,
          vsIgnoreDateRestrictions,
          vsColour,
          vsRyftSubAccountID,
          vsGoogleTagManagerID,
          vsReturnPage,
          vsWebHookURL,
          vsNoAvailabilityMessage,
          vsTimezone,
          vsCurrency,
          vsCulture,  
          vsSelectedPaymentLinkEmailTemplate,
          vsChosenHomePage,
          vsWaiverMinAge,
          vsSelectedVoucherEmailTemplate,
          vsSelectedCancelledBookingEmailTemplate,
          vsBookingsCannotBeMadeAfterXMinutes,
          vsBookingsCannotBeMadeWithinXMinutes,
          vsCannotMakeBookingsToday,
          vsBetaEmailing,
          vsBetaTask,
          vsBetamembership,
          vsBookingNotificationEmail,
          vsBookingNotification,
          vsWaiverActive,
          vsMinWaiverAge,
          vsMinWaiverAgeParticipate,
          vsSimRacingEnabled,
          vsSimRacingAPiKey,
          vsSimRacingVenueID
        ]
      };

      this.http.put<cVenuesettings>(bmxurl + "/venuesettings", this.venuesettings).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            if(showmessage)
              this.messageService.add({severity:'success', summary:'Saved', detail:'Venue Settings successfully updated'});

            //Reload VenueSettings
            this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
              this.httpResponse =  (response as venuesettings_returndata)
              if(this.httpResponse.succeeded)
              {
                //Set Venue Settings ID
                localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
        
                this.httpResponse.data.venueSettings.forEach(element => {
                  localStorage.removeItem(element.name);
                  localStorage.setItem(element.name, element.value);
                });
                
                // Execute callback if provided
                if (callback) {
                  callback();
                }
              }
              else{
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
            });

          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Venue Settings Not Saved', detail:error.messages});
        })
    }
  }

  getVenueSettings()
  {
      this.busyService.busy();
      this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse =  (response as venuesettings_returndata)
      if(this.httpResponse.succeeded)
      {
        //Set Venue Settings ID
        localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

        this.httpResponse.data.venueSettings.forEach(element => {
          localStorage.removeItem(element.name);
          localStorage.setItem(element.name, element.value);

          switch(element.name) {
            case "AvailabilityDiagnostics":
              this.vsDiagnostics = element.value === "true";
              break;
            case "PBWStyle":
              this.vsPBWStyle = element.value;
              break;
            case "MinimalDetails":
              this.vsMinimalDetails = element.value === "true";
              break;
            case "PublicImgURL":
              this.vsImageURL = element.value;
              break;
            case "ImageReturnURL":
              this.vsImageReturnURL = element.value;
              break;
            case "GTMCode":
              this.vsGTMCode = element.value;
              break;
            case "EMailSMSConfirmation":
              this.vsConfirmations = element.value;
              break;
            case "DefaultInterval":
              this.defInterval = parseInt(element.value) || 5;
              break;
            case "PublicImageWidth":
              this.imageWidth = parseInt(element.value) || 0;
              break;
            case "PublicImageheight":
              this.imageHeight = parseInt(element.value) || 0;
              break;
            case "idleTimeout":
              this.idleTimeout = parseInt(element.value) || 0;
              break;
            case "AllowTimeOut":
              this.AllowTimeOut = element.value === "true";
              break;
            case "RyftSubAccountID":
              this.RyftSubAccountID = element.value;
              break;
            case "GoogleTagManagerID":
              this.GoogleTagManagerID = element.value;
              break;
            case "returnPage":
              this.returnPage = element.value;
              break;
            case "WebHookURL":
              this.WebhookURL = element.value;
              break;
            case "NoAvailabilityMessage":
              this.NoAvailabilityMessage = element.value;
              break;
            case "UseCounters":
              this.UseCounters = element.value === "true";
              break;
            case "SummaryItinerary":
              this.SummaryItinerary = element.value === "true";
              break;
            case "IgnoreDateRestrictions":
              this.IgnoreDateRestrictions = element.value === "true";
              break;
            case "DefaultColour":
              this.defaultColour = element.value;
              break;
            case "TimeZone":
              this.chosenTimezone = element.value;
              break;
            case "Currency":
              this.chosenCurrency = element.value;
              break;
            case "Culture":
              this.chosenCulture = element.value;
              break;
            case "BookingsCannotBeMadeWithinXMinutes":
              this.BookingsCannotBeMadeWithinXMinutes = parseInt(element.value) || 0;
              break;
            case "BookingsCannotBeMadeAfterXMinutes":
              this.BookingsCannotBeMadeAfterXMinutes = parseInt(element.value) || 0;
              break;
            case "CannotMakeBookingsToday":
              this.CannotMakeBookingsToday = element.value === "true";
              break;
            case "BetaEmailing":
              this.betaemailing = element.value === "true";
              break;
            case "BetaTask":
              this.betatask = element.value === "true";
              break;
            case "Betamembership":
              this.betamembership = element.value === "true";
              break;
            case "PaymentAmountSelection":
              this.PaymentAmountSelection = element.value;
              break;
            case "ChosenHomePage":
              this.ChosenHomePage = {value: element.value, name: element.value};
              break;
            case "waiverminage":
              this.waiverminage = parseInt(element.value) || 18;
              break;
            case "PaymentLinkEmailTemplate":
              this.selectedPaymentLinkEmailTemplate = {emailtemplateid: element.value};
              break;
            case "VoucherEmailTemplate":
              this.selectedVoucherEmailTemplate = {emailtemplateid: element.value};
              break;
            case "CancelledBookingTemplate":
              this.selectedCancelledBookingEmailTemplate = {emailtemplateid: element.value};
              break;
            case "WaiverActive":
              this.WaiversActive = element.value === "true";
              break;
            case "WaiverMinAge":
              this.MinWaiverAge = {name: element.value + " Years", value: parseInt(element.value) || 18};
              break;
            case "MinWaiverAgeParticipate":
              this.WaiverMinAgeParticipate = {name: element.value + " Years", value: parseInt(element.value) || 0};
              break;
            case "simracing_enabled":
              this.SimRacingEnabled = element.value === "true";
              this.simracingEnabled = element.value === "true";
              break;
            case "simracing_apikey":
              this.SimRacingAPIKey = element.value;
              this.apiKey = element.value;
              break;
            case "simracing_venueid":
              this.SimRacingVenueID = element.value;
              break;
            case "BookingNotificationEmail":
              this.BNemail = element.value;
              break;
            case "BookingNotification":
              this.BookingNotification = element.value === "true";
              break;
          }

        });
        this.busyService.idle();
      }
      else{
        this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
      this.busyService.idle();
    });
  }

  loadSimracingSettings(): void {
    this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse = (response as venuesettings_returndata);
      if (this.httpResponse.succeeded) {
        let hasApiKey = false;
        let hasSelectedVenue = false;
        
        this.httpResponse.data.venueSettings.forEach(element => {
          if (element.name === "simracing_enabled") {
            this.simracingEnabled = element.value === "true";
            this.SimRacingEnabled = element.value === "true";
          } else if (element.name === "simracing_apikey") {
            this.apiKey = element.value || "";
            this.SimRacingAPIKey = element.value || "";
            hasApiKey = this.apiKey.length > 0;
          } else if (element.name === "simracing_venueid") {
            try {
              if (element.value && element.value.trim() !== "") {
                this.selectedVenue = JSON.parse(element.value);
                this.SimRacingVenueID = element.value;
                hasSelectedVenue = true;
              } else {
                this.selectedVenue = null;
                this.SimRacingVenueID = "";
              }
            } catch (e) {
              this.selectedVenue = null;
              this.SimRacingVenueID = "";
            }
          }
        });
        
        // If we have an API key and simracing is enabled, load venues
        if (hasApiKey && this.simracingEnabled) {
          this.loadVenuesFromAPI();
        }
      }
    }, error => {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'Unable to load SimRacing settings' 
      });
    });
  }

  getVenues(): void {
    if (!this.apiKey) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'Warning', 
        detail: 'Please enter an API Key first' 
      });
      return;
    }

    // Update internal variables from form controls
    this.SimRacingAPIKey = this.apiKey;
    this.SimRacingEnabled = this.simracingEnabled;
    // Clear selected venue since we're getting a fresh list
    this.selectedVenue = null;
    this.SimRacingVenueID = "";

    //Save Venue Settings and wait before loading the venues
    this.updateSettingsData(false, () => {
      this.loadVenuesFromAPI();
    });
  }

  private loadVenuesFromAPI(): void {
    this.venuesLoading = true;
    this.venues = [];
    this.noVenuesMessage = "";

    this.http.get(bmxurl + "/simracing/getvenues/" + this.VenueID).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded && this.httpResponse.data && this.httpResponse.data.length > 0) {
        this.venues = this.httpResponse.data.map(venue => ({
          label: venue.name,
          value: venue
        }));
        
        // If we had a previously selected venue, try to match it with the loaded venues
        if (this.selectedVenue && this.selectedVenue.id) {
          const matchedVenue = this.venues.find(v => v.value.id === this.selectedVenue.id);
          if (matchedVenue) {
            this.selectedVenue = matchedVenue.value;
          } else {
            // If the previously selected venue is not found, clear it
            this.selectedVenue = null;
            this.SimRacingVenueID = "";
          }
        }
        
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Success', 
          detail: `Found ${this.venues.length} venues` 
        });
      } else {
        this.noVenuesMessage = "No venues found for this API key";
        this.venues = [];
        this.selectedVenue = null;
        this.SimRacingVenueID = "";
      }
      this.venuesLoading = false;
    }, error => {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Error', 
        detail: 'Unable to fetch venues. Please check your API key.' 
      });
      this.venues = [];
      this.noVenuesMessage = "Error loading venues";
      this.selectedVenue = null;
      this.SimRacingVenueID = "";
      this.venuesLoading = false;
    });
  }

  saveSettings(): void {
    // Update internal variables from form controls before saving
    this.SimRacingEnabled = this.simracingEnabled;
    this.SimRacingAPIKey = this.apiKey;
    if (this.selectedVenue) {
      this.SimRacingVenueID = this.selectedVenue.value.id;
    } else {
      this.SimRacingVenueID = "";
    }

    this.updateSettingsData(false, () => {
      this.router.navigate(['/integrations']);
    });
  }

  goBack(): void {
    this.router.navigate(['/integrations']);
  }

  onSimracingEnabledChange(): void {
    // Update internal variable
    this.SimRacingEnabled = this.simracingEnabled;
    
    if (!this.simracingEnabled) {
      // Clear all related data when disabled
      this.apiKey = "";
      this.SimRacingAPIKey = "";
      this.selectedVenue = null;
      this.SimRacingVenueID = "";
      this.venues = [];
      this.noVenuesMessage = "";
    }
  }
}
